import { callApiToServer } from "../callApi";

export async function searchCompanyCard(
  authtoken,
  searchText,
  skipNumber,
  limitNumber,
  companyId,
  cardType
) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    const body = {
      search_text: searchText,
    };

    if (cardType && cardType !== "all") {
      body.card_type = cardType;
    }

    let endUrl =
      "v1/auth/filter-company-card/" +
      skipNumber +
      "/" +
      limitNumber +
      "/" +
      companyId;
    let responseData = await callApiToServer(
      JSON.stringify(body),
      header,
      "POST",
      endUrl
    );

    return responseData;
  } catch (err) {
    throw err;
  }
}
